import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};
const getBrowserSnapshot = () => true;
const getServerSnapshot = () => false;

export const useHydrated = (): boolean =>
  useSyncExternalStore(subscribe, getBrowserSnapshot, getServerSnapshot);
